import type { RouteRecordRaw } from 'vue-router'

import { __t } from '@/lib/helpers'
import MobileSubscription from '@/views/subscription-mobile/routes.js'
import Business from './business/index.ts'
import MobileConsents from '@/views/consent-mobile/routes.js'

const routes: RouteRecordRaw[] = [
  /*
   *
   * onboarding & onboarding related routes
   *
   */
  {
    path: '/onboarding-invites',
    name: 'onboarding-invites',
    component: () => import('@/views/onboarding-invites/index.vue'),
    meta: {
      useSmartlook: true,
    },
  },
  {
    path: '/onboarding-share',
    name: 'onboarding-share',
    component: () => import('@/views/onboarding-share/index.vue'),
  },
  {
    path: '/onboarding/:step?/:substep?',
    name: 'onboarding',
    component: () => import('@/views/onboarding/index.vue'),
    meta: {
      useSmartlook: true,
      pageTitle: __t('components.onboarding.intro.page.title'),
      description: __t('components.onboarding.intro.page.description'),
      generateHrefLangs: true,
    },
  },

  ...MobileSubscription as RouteRecordRaw[],

  ...MobileConsents as RouteRecordRaw[],

  /*
   *
   * business routes
   *
   */
  Business as RouteRecordRaw,
  {
    path: '/:catchAll(.*)*',
    name: '404',
    meta: { /* none */ },
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/auth-me',
    name: 'auth-me',
    component: () => import('@/views/auth-me.vue'),
    meta: {
      loginRequired: true,
    },
  },
]

// sandbox is available only for "development" env.
if (process.env.NODE_ENV !== 'production') {
  routes.unshift({
    path: '/sandbox:componentPath(.*)?',
    name: 'sandbox',
    component: () => import('@/views/sandbox.vue'),
  })

  routes.unshift({
    path: '/design-tokens',
    name: 'design-tokens',
    component: () => import('@/views/design-tokens.vue'),
  })
}

export default routes

/*
 * finds route by name
 * @param {String} route name
 * @return {Object|null} route or `null`
 */
export function findRoute (name: string): RouteRecordRaw | undefined {
  return findSubroute(name, routes)
}

/*
 * finds route by name
 * @param {String} route name
 * @param {Array} routes list
 * @return {Object|null} route or `null`
 */
function findSubroute (name: string, routes: RouteRecordRaw[]): RouteRecordRaw | undefined {
  for (const r of routes) {
    // shortcut: found!
    if (r.name === name) {
      return r
    }
    if (r.children) {
      const s = findSubroute(name, r.children)
      // shortcut: found!
      if (s) {
        return s
      }
    }
  }
}
